"use client";

import { Navbar } from "./navbar";
import { Hero } from "./hero";
import { ProblemSection } from "./problem-section";
import { AgentCollaboration } from "./agent-collaboration";
import { HowItWorks } from "./how-it-works";
import { BentoGrid } from "./bento-grid";
import { Platforms } from "./platforms";
import { Industries } from "./industries";
import { Stats } from "./stats";
import { Testimonials } from "./testimonials";
import { Comparison } from "./comparison";
import { FAQ } from "./faq";
import { Pricing } from "./pricing";
import { BlogPreview } from "./blog-preview";
import { BottomCTA } from "./bottom-cta";
import { Footer } from "./footer";

function Band({
  children,
  elevated,
}: {
  children: React.ReactNode;
  elevated?: boolean;
}) {
  return (
    <div className={elevated ? "bg-surface-secondary/40" : ""}>
      {children}
    </div>
  );
}

export default function Landing() {
  return (
    <div className="min-h-screen bg-surface text-content antialiased overflow-x-hidden">
      <div
        className="fixed inset-0 pointer-events-none z-0"
        aria-hidden="true"
      >
        <div
          className="absolute top-0 left-1/2 -translate-x-1/2 w-[1200px] h-[800px] rounded-full blur-[150px]"
          style={{
            background:
              "radial-gradient(circle, rgba(222,115,86,0.03) 0%, transparent 70%)",
          }}
        />
      </div>

      <div className="relative z-10">
        <Navbar />
        <Hero />

        <Band elevated>
          <ProblemSection />
        </Band>

        <AgentCollaboration />

        <Band elevated>
          <HowItWorks />
        </Band>

        <BentoGrid />

        <Band elevated>
          <Platforms />
        </Band>

        <Industries />

        <Stats />

        <Band elevated>
          <Testimonials />
        </Band>

        <Comparison />

        <Band elevated>
          <Pricing />
        </Band>

        <FAQ />

        <Band elevated>
          <BlogPreview />
        </Band>
        <BottomCTA />
        <Footer />
      </div>
    </div>
  );
}
